import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=0eac14be&scoped=true&"
import script from "./DashboardSection.vue?vue&type=script&lang=js&"
export * from "./DashboardSection.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=0eac14be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eac14be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardSectionHeader: require('/workspace/components/Dashboard/DashboardSectionHeader.vue').default})
